import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

type AnimatedLayoutVariant = 'default' | 'settings';

type AnimatedLayoutProps = {
    children: ReactNode;
    variant?: AnimatedLayoutVariant;
};

const defaultTransition = {
    duration: 0.22,
    ease: [0.22, 1, 0.36, 1] as [number, number, number, number],
};

const settingsTransition = {
    duration: 0.2,
    ease: [0.4, 0, 0.2, 1] as [number, number, number, number],
};

const AnimatedLayout = ({
    children,
    variant = 'default',
}: AnimatedLayoutProps) => {
    const isSettings = variant === 'settings';

    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={
                    isSettings
                        ? { opacity: 0, scale: 0.985, filter: 'blur(4px)' }
                        : { y: 10, opacity: 0 }
                }
                animate={
                    isSettings
                        ? { opacity: 1, scale: 1, filter: 'blur(0px)' }
                        : { y: 0, opacity: 1 }
                }
                exit={
                    isSettings
                        ? { opacity: 0, scale: 0.992, filter: 'blur(3px)' }
                        : { y: -6, opacity: 0 }
                }
                transition={
                    isSettings ? settingsTransition : defaultTransition
                }
                style={{ width: '100%' }}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
};

export default AnimatedLayout;
export type { AnimatedLayoutVariant };
